import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Form, Button, Typography, Card, Tabs, Modal, message, Space, Tooltip } from 'antd';
import {  QuestionCircleOutlined } from "@ant-design/icons";
import 'react-confirm-alert/src/react-confirm-alert.css';

import AdapterStart from 'components/adapter/unified/AdapterStart';
import AdapterInfo from 'components/adapter/unified/AdapterInfo';
import AdapterGet from 'components/adapter/unified/AdapterGet';
import AdapterPut from 'components/adapter/unified/AdapterPut';
import AdapterLock from 'components/adapter/unified/AdapterLock';
import AdapterUnlock from 'components/adapter/unified/AdapterUnlock';
import AdapterRefresh from 'components/adapter/unified/AdapterRefresh';
import AdapterImportAndExport from './AdapterImportAndExport';
import ConnectType from './ConnectType';

import * as types from 'reducer/actionTypes';
import { isEmpty } from 'script/common';

const UniAdapter = ({ t }) => {
	const webofficeURLParam = useSelector(state => state.uniAdapter?.adapterParamIsValid);
	const adapterList = useSelector(state => state.uniAdapter.adapterList);
	const [showCode, setShowCode] = useState(true);
	const [selectedAdapterName, setSelectedAdapterName] = useState('');
	const [activeTabName, setActiveTabName] = useState('');
	const [serviceParam, setServiceParam] = useState({});
    const connectParam = useSelector(state => state.uniAdapter.connectParam);
	/** ========================================================================================================================================== **/
	const dispatch = useDispatch();
	const fetchGetSampleWebofficeURL = (value) => {
		dispatch({type: types.FETCH_GET_SAMPLE_WEBOFFICE_URL_REQUEST, value: value})
	};
	const fetchGetUniAdapterParam = (value) => {
		dispatch({type: types.FETCH_GET_UNIADAPTER_PARAMETER_REQUEST, value: value})
	};
	const fetchSetSampleWebofficeURL = (value) => {
		dispatch({type: types.FETCH_SET_SAMPLE_WEBOFFICE_URL_REQUEST, value: value})
	};
	const fetchResetUniAdapterInterface = () => {
		dispatch({type: types.FETCH_SET_RESET_UNIADAPTER_INTERFACE_REQUEST})
	};
	const fetchGetUniAdapterList = () => {
		dispatch({type: types.FETCH_GET_UNIADAPTER_LIST_REQUEST})
	};
	const fetchGetConnectParameters = (value) => {
	dispatch({type: types.FETCH_GET_UNIADAPTER_CONNECT_PARAMETERS_REQUEST, value: value})
	};
	/** ========================================================================================================================================== **/

	useEffect(() => {
		setActiveTabName('start');
	}, [])
	
	useEffect(() => {
		fetchGetUniAdapterList();
	}, [dispatch]);

	useEffect(() => {
		if (adapterList.length > 0 ) {
			setSelectedAdapterName(prev => prev || adapterList[0]);
		}
	}, [adapterList]);

	useEffect(() => {
		if (selectedAdapterName) {
			fetchGetSampleWebofficeURL(selectedAdapterName);
			fetchGetUniAdapterParam(selectedAdapterName);
			fetchGetConnectParameters(selectedAdapterName);
		}
		setActiveTabName('start');
	}, [selectedAdapterName]);

	const toggleShowCode = () => {
		setShowCode((prev) => !prev);
	};

	// Save WebofficeURL
	const handleSave = () => {
		const _webofficeURL = document.getElementById('InputwebofficeURL').value;
		fetchSetSampleWebofficeURL({'webofficeURL' : _webofficeURL, 'adapterName' : selectedAdapterName})
		fetchGetUniAdapterParam(selectedAdapterName);
		fetchGetSampleWebofficeURL(selectedAdapterName);
	}

	const handleReset = () => {
		Modal.confirm({
			title: "Do you want to reset all saved UniAdapter interface settings?",
			onOk: () => {
				fetchResetUniAdapterInterface();
			},
			onCancel: () => {
				message.info("The reset has been canceled.");
			},
		});
	}

	const handleChange = (e) => {
		setSelectedAdapterName(e.target.value);
	}

	const handleMouseDown = (e) => {
		fetchGetUniAdapterList();
	}

	const handleTabChange = (key) => {
		const selected = interfaceList.find((item) => item.key === key);
		if (selected) {
		setActiveTabName(selected.name);
		}
  	};
	
	const interfaceList = [
		{
			label: `Start`,
			key: '1',
			name: 'start',
			children: <AdapterStart webofficeURLParam={webofficeURLParam} adapterName = {selectedAdapterName} tabName = {activeTabName}/>
		},
		{
			label: `Info`,
			key: '2',
			name: 'info',
			children: <AdapterInfo webofficeURLParam={webofficeURLParam} adapterName = {selectedAdapterName} tabName = {activeTabName}/>
		},
		{
			label: `Get`,
			key: '3',
			name: 'get',
			children: <AdapterGet webofficeURLParam={webofficeURLParam} adapterName = {selectedAdapterName} tabName = {activeTabName}/>
		},
		{
			label: `Put`,
			key: '4',
			name: 'put',
			children: <AdapterPut webofficeURLParam={webofficeURLParam} adapterName = {selectedAdapterName} tabName = {activeTabName}/>
		},
		{
			label: `Lock`,
			key: '5',
			name: 'lock',
			children: <AdapterLock webofficeURLParam={webofficeURLParam} adapterName = {selectedAdapterName} tabName = {activeTabName}/>
		},
		{
			label: `Unlock`,
			key: '6',
			name: 'unlock',
			children: <AdapterUnlock webofficeURLParam={webofficeURLParam} adapterName = {selectedAdapterName} tabName = {activeTabName}/>
		},
		{
			label: `Refresh`,
			key: '7',
			name: 'refresh',
			children: <AdapterRefresh webofficeURLParam={webofficeURLParam} adapterName = {selectedAdapterName} tabName = {activeTabName}/>
		},
		{
			label: `Import & Export`,
			key: '8',
			name: 'importExport',
			children: <AdapterImportAndExport webofficeURLParam={webofficeURLParam} adapterName = {selectedAdapterName}/>
		},
	]

	return(
		<div style={{ margin: "10px" }}>
			<h2>{"UniAdapter List"}</h2>
			<select className="item_dropdown_select active" id="selectUniAdapterList" value={selectedAdapterName} onChange={handleChange} onMouseDown={handleMouseDown}> 
				{adapterList.map((item, idx) => (
					<option value={item} key={idx}>
						{item}
					</option>
				))}
			</select>
			<Card
      			type="inner"
				title={
				<Space>
				<span>Connect Settings</span>
				<Tooltip title="Choose service type which you want to connect.">
					<QuestionCircleOutlined />
				</Tooltip>
				</Space>
			}
			style={{ marginTop: 20 }}
			headStyle={{ backgroundColor: "#26528a", color: "white" }}
    		>
			<ConnectType
    			initial={{ type: "aws-s3", params: { region: "ap-northeast-2" } }}
				selectedAdapterName = {selectedAdapterName}
    			onChange={(payload) => setServiceParam(payload)}
				connectParam = {connectParam}
			/>
			{/* sample - adapterParam data */}
			<Form.Item noStyle shouldUpdate>
				{() => {
					return isEmpty(webofficeURLParam) ? null : 
						(
							<Typography>
								<Button variant="contained" color="primary" onClick={toggleShowCode}>
									{showCode ? 'Hide' : 'Show'} AdapterParam
								</Button>
								{showCode && (
									<pre>
									<div style={{ color: '#c4bfc4' }}>
										AdapterParam(adapter.param) information to be saved <br />
									</div>
									{JSON.stringify(webofficeURLParam, null, 2)}
									</pre>
								)}
							</Typography>
						)
				}}
			</Form.Item>
			
			</Card>

			<Card 
				type="inner" 
				style={{ marginTop: 20 }} 
				headStyle={{ backgroundColor: '#26528a', color: 'white' }}
			>
				{/* Tabs : Adapter Interface*/}
				<Tabs
					key={`tabs-${selectedAdapterName}`}
					destroyInactiveTabPane
					defaultActiveKey="1"
					size="large"
					onChange={handleTabChange}
					items = {interfaceList}
				/>
			</Card>
		</div>
	)
}

export default UniAdapter;